import React, { FC } from "react";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import MDButton from "mdComponents/MDButton";
import { CorporateAccountAdmin } from "../models/corporateAccountAdminModel";
import { formatDate } from "../Utils";
import { Card } from "@mui/material";
import { useUser } from "../context/UserContext";

interface CorporateAdminListProps {
  admins: CorporateAccountAdmin[];
  onEditAdmin: (admin: CorporateAccountAdmin) => void;
  onRemoveAdmin: (admin: CorporateAccountAdmin) => void;
  onAddAdmin: () => void;
  title: string;
  description: string;
  noRecordsMessage?: string;
  paddingSides?: number;
}

const CorporateAdminList: FC<CorporateAdminListProps> = ({
  admins,
  onAddAdmin,
  onEditAdmin,
  onRemoveAdmin,
  title,
  description,
  noRecordsMessage,
  paddingSides = 0,
}) => {

    const { user } = useUser();
  return (
    <MDBox display="flex" flexDirection="column" width="100%" pl={paddingSides} pr={paddingSides}>
        <MDBox pt={2}>
          <MDTypography
            variant="h6"
            fontWeight="medium"
            textTransform="capitalize"
          >
            {title}
          </MDTypography>
          <MDTypography
            color="text"
            fontWeight="light"
            sx={{
              fontSize: "0.85rem",
              lineHeight: 1.2,
              display: "block",
            }}
          >{description}</MDTypography>

            {user.isCorporateAccountOwner && 
            <MDBox pt={1}>
                <MDButton variant="gradient" size="small" color="info"  onClick={onAddAdmin}>Add Admin</MDButton>
            </MDBox>}
        </MDBox>


        <MDBox pb={2}>
        {!admins || admins.length === 0 &&
            <MDTypography variant="caption" p={2}>{noRecordsMessage ?? "No records to display."}</MDTypography>
        ||
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>

            {admins.map((admin) => (
              <MDBox
                key={admin.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  pt:1,
                  pb:0,
                  borderRadius: "md",
                }}
              >
                <MDBox sx={{ flex: 1 }}>
                  <MDTypography variant="body2" fontWeight="medium">
                    {admin.email}
                  </MDTypography>
                  <MDTypography variant="caption" color="text"sx={{
                        fontSize: "0.85rem",
                        lineHeight: 1.2,
                        display: "block",
                        }}>
                    {`Admin since ${formatDate(admin.created_at, true)}`}
                  </MDTypography>
                </MDBox>

                {/* Action buttons */}
                {user.isCorporateAccountOwner && 
                    <MDBox sx={{ display: "flex", gap: 1 }}>
                    <MDButton color="info" variant="outlined" size="small" onClick={(e) => {
                        e.stopPropagation();
                        onEditAdmin(admin);
                        }}
                    >Edit</MDButton>
                    <MDButton color="error" variant="outlined" size="small" onClick={(e) => {
                        e.stopPropagation();
                        onRemoveAdmin(admin);
                        }}
                    >Remove</MDButton>
                    </MDBox>
                }
              </MDBox>
            ))}


          </MDBox>
            }
        </MDBox>

    </MDBox>
  );
};

export default CorporateAdminList;
